module.exports = __webpack_public_path__ + "static/media/komikax_-webfont.073f63e5.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/themes/fonts/komikax_-webfont.woff2
// module id = 329
// module chunks = 1